import { db } from "@/firebase/init";
import { isMultiDocUser, getOrderedHostingDocs } from '@/utils/firestoreUtils';

export default {
  namespaced: true,
  state: {
    watchingSupervisorAccounts: false,
    accountListener: null,
    hostingAccounts: [],
    hostingAccOrdered: [],
    accountLength: 0,
    nextAccountNumber: 0,
    newPlanStructure: {
      planName: null,
      diskSpace: 10240,
      migration: {
        count: 0,
        log: []
      },
      primary: {
        domain: null,
        serverIP: null,
        status: null,
        comparisonID: null,
        flushOpcacheURL: null,
        freashInstall: false,
        ftp: {
          host: null,
          port: "21",
          mode: "FTP (explicit SSL)",
          pasv: "Ensure is Checked/Enabled",
          username: null,
          password: null,
          accounts: [
              {
                  username: null,
                  password: null,
              }
          ]
        },
        phpMyAdmin: {
          url: null,
          popupUsername: null,
          popupPassword: null,
          username: null,
          password: null
        },
        cloudflare: {
          username: null,
          password: null,
          userKey: null,
          apiKey: null,
          zone_id: null,
          nameserver1: null,
          nameserver2: null
        },
        manualBackups: [],
        redirects: [],
        staging: {
          enabled: false,
          domain: null,
          flushOpcacheURL: null,
          freashInstall: false,
          ftp: {
            host: null,
            port: "21",
            mode: "FTP (explicit SSL)",
            pasv: "Ensure is Checked/Enabled",
            username: null,
            password: null,
            accounts: [
                {
                    username: null,
                    password: null,
                }
            ]
          },
          phpMyAdmin: {
            url: null,
            popupUsername: null,
            popupPassword: null,
            username: null,
            password: null
          },
          manualBackups: [],
          redirects: []
        }
      },
      planLimit: 0,
      extraDomains: 0,
      maxStorageSize: 10,
      maxVisitors: 250000,
      addon: []
    },
    addonDomainStructure: {
      domain: null,
      chargable: false,
      serverIP: null,
      status: null,
      comparisonID: null,
      flushOpcacheURL: null,
      freashInstall: false,
      ftp: {
        host: null,
        port: "21",
        mode: "FTP (explicit SSL)",
        pasv: "Ensure is Checked/Enabled",
        username: null,
        password: null,
        accounts: [
            {
                username: null,
                password: null,
            }
        ]
      },
      phpMyAdmin: {
        url: null,
        popupUsername: null,
        popupPassword: null,
        username: null,
        password: null
      },
      cloudflare: {
        username: null,
        password: null,
        userKey: null,
        apiKey: null,
        zone_id: null,
        nameserver1: null,
        nameserver2: null
      },
      manualBackups: [],
      redirects: [],
      staging: {
        enabled: false,
        domain: null,
        flushOpcacheURL: null,
        freashInstall: false,
        ftp: {
          host: null,
          port: "21",
          mode: "FTP (explicit SSL)",
          pasv: "Ensure is Checked/Enabled",
          username: null,
          password: null,
          accounts: [
              {
                  username: null,
                  password: null,
              }
          ]
        },
        phpMyAdmin: {
          url: null,
          popupUsername: null,
          popupPassword: null,
          username: null,
          password: null
        },
        manualBackups: [],
        redirects: []
      }
    },
    userAccountFilters: null,
    docID: null
  },
  getters: {
    getAccountFilters(state) {
      return state.userAccountFilters;
    },
    isWatchingSupervisorAccounts(state){
      return state.watchingSupervisorAccounts;
    },
    accountListener(state){
      return state.accountListener;
    },
    accounts(state) {
      return state.hostingAccounts;
    },
    accountsOrdered(state) {
      return state.hostingAccOrdered;
    },
    activeAccounts(state) {
      if (state.hostingAccOrdered.length > 0) {
        const activeAccounts = state.hostingAccOrdered.filter(acc => {
          return acc.status === "active";
        });
        return activeAccounts;
      }
    },
    pendingAccounts(state) {
      if (state.hostingAccOrdered.length > 0) {
        const pendingAccounts = state.hostingAccOrdered.filter(acc => {
          return acc.status === "pending";
        });
        return pendingAccounts;
      }
    },
    plans(state) {
      if (state.hostingAccounts && Object.keys(state.hostingAccounts).length > 0) {
        const plansArr = [];
        state.hostingAccounts.forEach((acc, index) => {
          plansArr.push({
            planName: (acc.primary.domain === '') ? `${acc.planName}` : `${acc.planName} - ${acc.primary.domain}`,
            planIndex: index,
            planIP: acc.primary.serverIP
          });
        });
        return plansArr;
      }
    },
    newPlanStructure(state) {
      return state.newPlanStructure
    },
    addonDomainStructure(state) {
      return state.addonDomainStructure
    },
    getLength(state) {
      return state.accountLength;
    },
    getNextAccountNumber (state) {
      return state.nextAccountNumber;
    }
  },
  mutations: {
    updateUserAccountFilters(state, payload){
      state.userAccountFilters = payload;
    },
    updateIsWatchSupervisorAccountFlag(state, payload){
      state.watchingSupervisorAccounts = payload;
    },
    updateAccountListener(state, payload){
      state.accountListener = payload;
    },
    loadAccountsMutate(state, payload) {
      state.hostingAccounts = payload.accounts;
    },
    setDocID(state, payload) {
      state.docID = payload;
    },
    loadAccountsWithOrderMutate(state, payload) {
      const data = payload.accounts;
      const hostingAccounts = [];
      const allowedDomains = payload.allowedDomains;
      const userData = JSON.parse(localStorage.getItem("userDtls"));
      let number = 1;
      let colorIndex = 0;

      data.forEach((acc) => {
        // Push primary domain data
        if (allowedDomains && allowedDomains.includes(acc.primary.domain)) {
          hostingAccounts.push({
            ...acc.primary,
            type: "Primary Domain",
            planType: acc.planType || 'standalone',
            siteType: acc.primary.siteType || 'standalone',
            maxSubSitesLimit: acc.maxSubSitesLimit || 0,
            maxSubSitesAddonLimit: acc.primary.maxSubSitesAddonLimit || 0,
            planName: acc.planName,
            colorIndex,
            planIndex: acc.primary.planIndex, // Using the provided planIndex
            addonPrimaryDomain: null,
            primaryPhpMyAdmin: acc.primary.phpMyAdmin,
            addonPrimaryPlan: null,
            pServerIp: acc.primary.serverIP,
            pDomain: acc.primary.domain,
            planLimit: acc.planLimit,
            extraDomains: acc.extraDomains,
            addonIndex: null,
            maxStorageSize: acc.maxStorageSize,
            maxVisitors: acc.maxVisitors,
            maxMigrations: acc.maxMigrations,
            migration: acc.migration,
            fullDiskSpace: acc.fullDiskSpace,
            accountNumber: number,
            tag: acc.tag || "",
            tagColor: acc.tagColor || "",
          });
        } else if (!allowedDomains) {
          if (acc.primary.domain === "" && userData.userType === "normal") {
            return;
          }
          hostingAccounts.push({
            ...acc.primary,
            type: "Primary Domain",
            planType: acc.planType || 'standalone',
            siteType: acc.primary.siteType || 'standalone',
            maxSubSitesLimit: acc.maxSubSitesLimit || 0,
            maxSubSitesAddonLimit: acc.primary.maxSubSitesAddonLimit || 0,
            planName: acc.planName,
            colorIndex,
            planIndex: acc.primary.planIndex, // Using the provided planIndex
            addonPrimaryDomain: null,
            addonPrimaryPlan: null,
            primaryPhpMyAdmin: acc.primary.phpMyAdmin,
            planLimit: acc.planLimit,
            extraDomains: acc.extraDomains,
            addonIndex: null,
            pServerIp: acc.primary.serverIP,
            pDomain: acc.primary.domain,
            maxStorageSize: acc.maxStorageSize,
            maxVisitors: acc.maxVisitors,
            maxMigrations: acc.maxMigrations,
            migration: acc.migration,
            fullDiskSpace: acc.fullDiskSpace,
            accountNumber: number,
            tag: acc.tag || "",
            tagColor: acc.tagColor || "",
          });
        }

        // Push addon domain data
        acc.addon.forEach((addonAcc) => {
          number += 1;
          if (allowedDomains && allowedDomains.includes(addonAcc.domain)) {
            hostingAccounts.push({
              ...addonAcc,
              type: "Addon Domain",
              siteType: addonAcc.siteType || 'standalone',
              maxSubSitesAddonLimit: addonAcc.maxSubSitesAddonLimit || 0,
              planType: acc.planType || 'standalone',
              addonPrimaryDomain: acc.primary.domain,
              primaryPhpMyAdmin: acc.primary.phpMyAdmin,
              addonPrimaryPlan: acc.primary.domain + ":" + acc.primary.serverIP,
              planName: acc.planName,
              colorIndex,
              planIndex: acc.primary.planIndex, // Using the parent's planIndex
              pServerIp: acc.primary.serverIP,
              pDomain: acc.primary.domain,
              hbServiceID: acc.primary.hbServiceID,
              solusVM_VPS_ID: acc.primary.solusVM_VPS_ID,
              backupServer: acc.primary.backupServer,
              backupUser: acc.primary.backupUser,
              addonIndex: addonAcc.addonIndex, // Using the provided addonIndex
              accountNumber: number,
              suspended: acc.primary.suspended,
              hbHostname: acc.primary.hbHostname,
            });
          } else if (!allowedDomains) {
            if (addonAcc.domain === "" && userData.userType === "normal") {
              return;
            }
            hostingAccounts.push({
              ...addonAcc,
              type: "Addon Domain",
              siteType: addonAcc.siteType || 'standalone',
              maxSubSitesAddonLimit: addonAcc.maxSubSitesAddonLimit || 0,
              planType: acc.planType || 'standalone',
              addonPrimaryDomain: acc.primary.domain,
              primaryPhpMyAdmin: acc.primary.phpMyAdmin,
              addonPrimaryPlan: acc.primary.domain + ":" + acc.primary.serverIP,
              pServerIp: acc.primary.serverIP,
              pDomain: acc.primary.domain,
              planName: acc.planName,
              planIndex: acc.primary.planIndex, // Using the parent's planIndex
              addonIndex: addonAcc.addonIndex, // Using the provided addonIndex
              accountNumber: number,
              colorIndex,
              suspended: acc.primary.suspended,
              hbHostname: acc.primary.hbHostname,
            });
          }
        });
        number += 1;
        colorIndex += 1
      });
      state.hostingAccOrdered = hostingAccounts;
      state.nextAccountNumber = number;
    },
    loadAccOrderedMutate(state, payload) {
      state.hostingAccOrdered = payload.accounts;
    },
    mutateAddNewAccount (state, payload) {
      state.hostingAccOrdered.unshift(payload);
      state.nextAccountNumber += 1;
    },
    removeNewAccount (state, payload) {
      state.hostingAccOrdered.splice(state.hostingAccOrdered.indexOf(payload), 1);
      state.nextAccountNumber -= 1;
    },
    mutateRemoveNewAccount (state, payload) {
      let indexToBeRemove = -1;
      state.hostingAccOrdered.forEach((acc, index) => {
        if (acc.accountNumber === payload) {
          indexToBeRemove = index;
        }
      });
      state.hostingAccOrdered.splice(indexToBeRemove, 1);
    },
    mutateLength (state, payload) {
      state.accountLength = payload;
    }
  },
  actions: {
    loadAccounts(context, payload) {
      context.commit("loadAccountsMutate", payload);
      context.commit("loadAccountsWithOrderMutate", payload);
    },
    loadAccountsOrdered({ commit }, payload = {}) {
      commit("loadAccOrderedMutate", payload);
    },
    fetchAccounts(context, payload) {
      // Set asyncDone to false
      // context.dispatch("async/stateUpdate", { state: false }, { root: true });
      let UID = context.rootGetters.getUID;

      if(payload && payload.UID !== undefined){
          UID = payload.UID;
      }
      return new Promise((resolve, reject) => {
          db.collection("hostingAccounts")
              .doc(UID)
              .get()
              .then(doc => {
                  // Pass the data to the Vuex store
                  console.log(payload);
                  if(payload && payload.allowedDomains){
                    let data = doc.data();
                    data.allowedDomains = payload.allowedDomains;
                    console.log(data);
                    context.commit("loadAccountsMutate", doc.data());
                    context.commit("loadAccountsWithOrderMutate", data);
                  }else{
                    context.commit("loadAccountsMutate", doc.data());
                    context.commit("loadAccountsWithOrderMutate", doc.data());
                  }


                  // Set asyncDone to true
                  context.dispatch(
                      "async/stateUpdate",
                      { state: true },
                      { root: true }
                  );
                  resolve(doc.data());
              })
              .catch(err => {
                  // Show error message for 5 sec
                  context.dispatch(
                      "alert/update",
                      {
                          type: "danger",
                          message: err.message,
                          show: true
                      },
                      { root: true }
                  );

                  // setTimeout(() => {
                  //     context.dispatch(
                  //         "alert/showUpdate",
                  //         { show: false },
                  //         { root: true }
                  //     );
                  // }, 5000);
                  reject(err);
              });
      });
        // Connect to firestore database and fecth hosrting account data
    },
    clearAccounts(context) {
        context.commit("loadAccountsMutate", []);
        context.commit("loadAccountsWithOrderMutate", {accounts: []});
    },
    fetchBackupsOfDomain(context, payload){
      return new Promise(resolve => {
        db.collection("hostingAccounts").doc(payload.UID).get().then(doc => {
          const { accounts } = doc.data();
          accounts.map(account => {
            const { primary } = account;
            const { addon } = account;
            if(primary.domain === payload.domain){
              resolve(primary.manualBackups);
            }
            if(primary.staging.domain === payload.domain){
              resolve(primary.staging.manualBackups);
            }
            addon.map(item => {
              if(item.domain === payload.domain){
                resolve(item.manualBackups);
              }
              if(item.staging.domain === payload.domain){
                resolve(item.staging.manualBackups);
              }
            });
          });
        });
      });
    },
    fetchAccountsAdmin(context, payload) {
      console.log('here here 123123123')
      // Set asyncDone to false
      context.dispatch("async/stateUpdate", { state: false }, { root: true });

      (async () => {
        try {
          let accountsList = [];

          // Use utility functions to determine doc references
          const docRefs = isMultiDocUser(payload.UID)
            ? await getOrderedHostingDocs(payload.UID)
            : [db.collection("hostingAccounts").doc(payload.UID)];
          console.log('asdasd, asdasd')
          for (const docRef of docRefs) {
            let planIndex = 0;
            const docSnap = await docRef.get();
            if (!docSnap.exists) continue;

            const { accounts } = docSnap.data();
            const docId = docRef.id;
            console.log('asdasd', docId)
            const docType = docId === payload.UID ? "primary" : "secondary";

            const processedAccounts = accounts.map(acc => {
              acc.primary.planIndex = planIndex++;
              acc.primary.sourceUid = docId;
              acc.primary.docType = docType;

              acc.addon = acc.addon.map((addon, addonIndex) => {
                addon.addonIndex = addonIndex;
                addon.sourceUid = docId;
                addon.docType = docType;
                return addon;
              });

              return acc;
            });

            accountsList = [...accountsList, ...processedAccounts];
          }

          // Commit processed accounts
          context.commit("loadAccountsMutate", { accounts: accountsList });
          context.commit("loadAccountsWithOrderMutate", {
            accounts: accountsList,
            allowedDomains: payload.allowedDomains,
          });

          context.dispatch("async/stateUpdate", { state: true }, { root: true });

        } catch (err) {
          console.error("Error fetching accounts:", err.message);

          context.dispatch("alert/update", {
            type: "danger",
            message: err.message,
            show: true,
          }, { root: true });

          setTimeout(() => {
            context.dispatch("alert/showUpdate", { show: false }, { root: true });
            context.dispatch("async/stateUpdate", { state: true }, { root: true });
          }, 5000);
        }
      })();
    },
    createRealTimeSnapShotOnUserAccount(context){
      let UID = context.rootGetters.getUID;
      let query = db.collection('hostingAccounts').doc(UID);
      let accountListener = query.onSnapshot(() => {
        console.log('Changes in this account. Fetch Fresh Data...');
        context.dispatch('fetchAccounts');
      });
      context.commit('updateAccountListener', accountListener);
    }
  }
};
